// extracted by mini-css-extract-plugin
export default {"BindPhoneModal":"index_BindPhoneModal__bIy9L","Form":"index_Form__qYVJK","CheckboxWrap":"index_CheckboxWrap__Pgw6m","title":"index_title__sLAQ9","text":"index_text__RsdnP"};